<p *ngIf="isRegistrationError && registrationErrorMsg" class="alert alert-warning font-weight-bold text-center"><i class="mdi mdi-error"></i>{{registrationErrorMsg}}</p>
<div *ngIf="showSuccessPane && registrationMsg">
  <p class="alert alert-success font-weight-bold text-center"><i class="mdi mdi-error"></i>{{registrationMsg}}</p>
  <p class="text-links-wrap">
    <a routerLink="/access/login" class="text-link">Back to login</a>
    <a routerLink="/access/resendemailverification" class="text-link text-right">Resend verification email</a>
  </p>
</div>
<form *ngIf="!showSuccessPane"  #registerForm="ngForm" name="registerForm" class="m-0" (ngSubmit)="OnSubmit(Name.value, Email.value, Password.value)" autocomplete="off">
  <div class="fieldset">
    <label for="Email" class="legend">Email</label>
    <input type="email" name="Email" id="Email" class="text-field" [disabled]="this.registrationService_.isLoading" ngModel #Email required>
  </div>
  <div class="fieldset">
    <label for="Password" class="legend">Password</label>
    <input type="password" name="Password" id="Password" class="text-field" [disabled]="this.registrationService_.isLoading" ngModel #Password required>
  </div>
  <div class="fieldset">
    <label for="Name" class="legend">Full Name</label>
    <input type="text" name="Name" id="Name" class="text-field" [disabled]="this.registrationService_.isLoading" ngModel #Name required>
  </div>
  <button *ngIf="!this.registrationService_.isLoading; else isLoading" type="submit" class="btn m-auto" [disabled]="this.registerForm.invalid">Register</button>
  <ng-template #isLoading>
    <button class="btn btn--loading" type="button">Registering...</button>
  </ng-template>
  <div class="fieldset mt-3">
    <p class="text-center text-sm mb-1">Or</p>
    <hr class="m-0 mb-2"/>
      <iframe [src]="googleauthuri" width="100%" height="50px" scrolling="no" frameborder="0"></iframe>
  </div>
</form>

<!-- <div class="modal fade" #registerexistingstudent id="registerexistingstudent" aria-hidden="true" aria-labelledby="registerexistingstudent" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Existing User Found</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p></p>
        <form #uploadform="ngForm" (ngSubmit)="enrolstudent(files.files)" name="uploadform">
          <p class="text-center text-sm">{{enrolFileName || 'No File Selected'}}</p>
          <button (click)="files.click()" type="button" id="filesLabel" class="btn btn--dashed m-auto">Select File</button>
        </form>
      </div>
    </div>
  </div>
</div> -->